// extracted by mini-css-extract-plugin
export default {"main":"d966a23219 _1c6101c1c5","xmark":"_1fbb71fdee","fl_img":"_0707c3a0a2 _522a19e1b4"};